import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_oigrk5zybt: FaireBrandEntity = {
  token: "b_oigrk5zybt",
  type: "brand",
  name: "Sagebrook Home",
  avatarUrl:
    "https://cdn.faire.com/fastly/fe626a5ce134edfc7954ae11deddd961f4aaa53f1d24b0439b79e9445923a636.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9e5b43079c7ead92c212e992d3b4bf9849a0245f8308d1617125b61b456cc075.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fe626a5ce134edfc7954ae11deddd961f4aaa53f1d24b0439b79e9445923a636.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9e5b43079c7ead92c212e992d3b4bf9849a0245f8308d1617125b61b456cc075.jpeg",
  location: "Commerce, CA, USA",
  minimumOrderDollars: 208,
  rating: 4.8,
  reviewCount: 339,
  isTopShop: true,
  isInsider: true,
  description:
    "Founded in March 2015, Sagebrook Home is based in Los Angeles, California. Known for staying ahead of trends, Sagebrook Home introduces over 4,000 new items per year and our catalog currently includes over 10,000 products spanning accessories, furniture, wall art, garden, and lighting. Sagebrook Home caters to a variety of styles including modern, glam, contemporary, coastal as well as transitional. Utilizing a “Service Excellence” policy, Sagebrook Home has unmatched customer service while maintaining affordability and accessibility for our partners in the design trade. By utilizing state-of-the-art technology, SBH has quickly become a leader in delivery, fulfillment and drop shipping. ",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:41.058Z",
    importedBy: "entity-db-cli",
  },
};
